// extracted by css-extract-rspack-plugin
export default {"notification":"notification--HTfhNyIFvhMPef1L"};